"use client";

import usePageTracking from "@/hooks/usePageTracking";
import { builder } from "@builder.io/sdk";

interface PageTrackerInitProps {
  builder_api_key: string;
}

const PageTracker: React.FC<PageTrackerInitProps> = ({ builder_api_key }) => {
  builder.init(builder_api_key);
  usePageTracking();

  return null; // No UI is needed for the tracker
};

export default PageTracker;
